module.exports = [{"type":"hash","text":"Service Address"},{"type":"code","text":"https://open-api.bingx.com"},{"type":"normal","text":"Alternate domain name: open-api.bingx.io (total frequency limit: 60/min) Release the frequency limit of the alternate domain name only when there is a problem with the primary domain name open-api.bingx.com"},{"type":"normal","text":"HTTP 200 status code indicates a successful response. The response body might contain a message which will be displayed accordingly."}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/api/basic/01_server_url.json
// module id = wWlE
// module chunks = 3